import React from "react";
import DefaultLayout from "../../Layouts/DefaultLayout";
import { useStoreContext } from "../../Contexts/StoreContext";
import DefaultLayoutProfile from "../../Layouts/DefaultLayoutProfile";

const ProfileChangePassword = () => {
    const { currentStore } = useStoreContext();
    document.title = 'Alterar senha';

    return (
        <DefaultLayout showHeader={currentStore}>
            <DefaultLayoutProfile>
                <div className="flex flex-col gap-4 p-2">
                    <h4 className="flex items-center justify-between font-semibold">ProfileChangePassword</h4>
                    <div className="flex items-center justify-between text-xs text-gray-400 gap-4">
                        Content
                    </div>
                </div>
            </DefaultLayoutProfile>
        </DefaultLayout>
    );
};

export default ProfileChangePassword;